import { Inventory } from '../inventory/types';
import { BinLocation, ZoneGroup } from './types';

export function groupBinsByZone(binLocations: BinLocation[]): ZoneGroup[] {
  const map = new Map<string, ZoneGroup>();
  for (const bin of binLocations) {
    const zoneLabel = bin.parentZone ? `${bin.parentZone} › ${bin.zone}` : bin.zone;
    if (!map.has(zoneLabel)) {
      map.set(zoneLabel, { zoneLabel, bins: [] });
    }
    const group = map.get(zoneLabel);
    if (group) group.bins.push({ binCode: bin.binCode, quantity: bin.quantity });
  }
  return Array.from(map.values());
}

export function groupInventoryByZone(inventories: Inventory[]): ZoneGroup[] {
  const map = new Map<string, ZoneGroup>();
  for (const inv of inventories) {
    const zone = inv.warehouseBin?.warehouseZone;
    const zoneName = zone?.name ?? 'Unknown';
    const parentName = zone?.parentWarehouseZone?.name ?? null;
    const zoneLabel = parentName ? `${parentName} › ${zoneName}` : zoneName;
    if (!map.has(zoneLabel)) {
      map.set(zoneLabel, { zoneLabel, bins: [] });
    }
    const group = map.get(zoneLabel);
    if (group) group.bins.push({ binCode: inv.warehouseBin?.code ?? '—', quantity: inv.quantity });
  }
  return Array.from(map.values());
}
